<wsd-extended-card
  [loading]="!(summaryNotes$ | async)"
  [redirectTo]="['/organizations', organizationId, 'modify', 'reporting']"
  [title]="'DATA_PORTAL.SUMMARY_NOTES.TITLE' | translate">
  <div *ngIf="summaryNotes$ | async as data">


    <div *ngIf="!data.keySummary" class="key-summary">
      <div class="m-b-15 key-summary text-center">
<!--        {{ 'DATA_PORTAL.SUMMARY_NOTES.EMPTY' | translate }}-->
      </div>
    </div>

    <div *ngIf="data.keySummary" class="key-summary text-center">
      <p class="hidden-content">{{ data.keySummary }}</p>
    </div>
    <a (click)="showModal = !showModal" *ngIf="data.keySummary?.length > 73">{{ 'DATA_PORTAL.SUMMARY_NOTES.READ_MORE' | translate }}</a>

    <div class="text-center grey-hint-text">
      <a
        *ngIf="data.summaryNoteId"
        (click)="getSummaryNote(data.summaryNoteId)"><i class="fa fa-download fa-2x"></i>
        <br>
        <span class="download-text">
          {{ 'DATA_PORTAL.SUMMARY_NOTES.SUMMARY_NOTE' | translate }}
        </span>
      </a>
    </div>

    <div *ngIf="!data.summaryNoteId" class="text-center grey-hint-text">
      <div class="m-b-5 m-t-10">
        <i class="fa fa-times-circle fa-lg text-danger"></i>
        <a class="upload" [routerLink]="['/organizations', organizationId, 'modify', 'reporting']">
          {{ 'DATA_PORTAL.UPLOAD' | translate }}
        </a>
      </div>
      {{ 'DATA_PORTAL.SUMMARY_NOTES.NO_SUMMARY' | translate }}
    </div>

  </div>
</wsd-extended-card>

<p-dialog [header]="'DATA_PORTAL.SUMMARY_NOTES.TITLE' | translate"
          [(visible)]="showModal">
  {{ (summaryNotes$ | async)?.keySummary }}
</p-dialog>
